<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="10">
                    <h3>{{ this.$route.name }}</h3>
                 </b-col>
                 <b-col md="2">
                    <b-button v-if="can('sistema.store')" @click="navigate('/sistema/cadastrar')" block variant="primary">
                         <i class="fa fa-plus"></i>
                       <span>Novo Cliente</span>
                    </b-button>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Nome do Sistema:">
                        <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="4">
                    <b-form-group label="Número do Cadastro:">
                        <b-form-input type="number" id="numCadastro" v-model="filtros.numCadastro"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group label="Área Responsável:">
                        <b-form-input type="text" id="areaResponsavel" v-model="filtros.areaResponsavel" placeholder="Nome da área"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group>
                        <b-form-group label="Situação:">
                            <b-form-select v-model="filtros.situacao" id="checkbox-group-2" :options="situacoes"></b-form-select>
                        </b-form-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-button @click="resetForm()" block>
                    <span>Limpar Filtros</span>
                </b-button>
              </b-col>
            </b-row>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                       <span>
                          <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Nº do Cadastro</th>
                              <th scope="col">Nome do Sistema</th>
                              <th scope="col">Área Responsável</th>
                              <th scope="col">Situação</th>
                              <th scope="col">Ações</th>
                            </tr>
                          </thead>

                          <tbody v-if="sistemas.data !== undefined">
                            <tr class="action" v-for="sistema in sistemas.data" :key="sistema.id">

                              <td>{{sistema.id}}</td>
                              <td>{{sistema.nome}}</td>
                              <td>{{sistema.area_responsavel}}</td>
                              <td>
                                <span v-if="sistema.status === true" class="badge badge-success">Ativo</span>
                                <span v-else class="badge badge-dark">Inativo</span>
                              </td>
                              <td style="width: 15%">
                                  <a v-if="can('sistema.update')" class="btn btn-sm btn-secondary action" title="Editar" @click="editarSistema(sistema.id)">
                                     <i class="fa fa-pencil-square-o"></i>
                                  </a>

                                  <span>
                                     <a v-if="can('sistema.destroy')" class="btn btn-sm btn-secondary action" title="Excluir" @click="modal(sistema.id, 'Excluir')">
                                      <i class="fa fa-times"></i>
                                     </a>
                                  </span>

                                  <span>
                                     <a v-if="can('sistema.generateKey') || can('sistema.generateId')"
                                            class="btn btn-sm btn-secondary action" title="Credenciais" @click="modal(sistema.id, 'Credenciais')">

                                      <i class="fa fa-key"></i>
                                     </a>
                                  </span>

                                  <span>
                                     <a v-if="can('sistema.show')" class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizarSistema(sistema.id)">
                                      <i class="fa fa-search"></i>
                                     </a>
                                  </span>

                                  <span v-if="can('sistema.deactivate') && sistema.status">
                                     <a tabindex="3" class="btn btn-sm btn-secondary action" title="Desativar" @click="modal(sistema.id, 'Desativar')">
                                      <i class="fa fa-toggle-on"></i>
                                     </a>
                                  </span>

                                  <span v-if="can('sistema.activate') && !sistema.status">
                                     <a tabindex="4" class="btn btn-sm btn-secondary action" title="Ativar" @click="modal(sistema.id, 'Ativar')">
                                      <i class="fa fa-toggle-off"></i>
                                     </a>
                                  </span>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                             <td colspan="9">Nenhum registro de clientes...</td>
                           </tr>
                          </tbody>
                         </table>
                          <pagination v-show="sistemas.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
                       </span>
                </b-container>
            </b-col>
        </b-row>
      </b-card>
      <b-modal :title="titulo_descricao" size="lg" :ok-title="credenciais ? 'Finalizar' : titulo_botao" cancel-title="Cancelar"
                v-model="modalControl" :ok-only="credenciais" :ok-variant="credenciais ? 'secondary' : 'primary'" @ok=" credenciais ? null : modalConfirma()">
         <b-card-body>
             <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nº do Cadastro:">
                  <b-input-group class="mb-6">
                    <b-form-input id="id"
                                  type="number"
                                  :disabled="true"
                                  class="form-control"
                                  placeholder="Número do Cadastro"
                                  autocomplete="id"
                                  v-model="sistema.id"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nome do Sistema:">
                  <b-input-group class="mb-6">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model="sistema.nome"
                                  :disabled="true"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Área Responsável:">
                  <b-input-group class="mb-6">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Área responsável"
                                  autocomplete="area_responsavel"
                                  :disabled="true"
                                  v-model.trim="sistema.area_responsavel"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="modalTipo === 'Credenciais'">
              <b-col cols="9">
                <b-form-group label="Client ID:">
                  <b-input-group class="mb-6">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  :readonly="true"
                                  v-model.trim="sistema.client_id"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="2" style="padding-top: 30px">
                <a v-if="can('sistema.generateId')" class="btn btn-sm btn-secondary action" @click="getId(sistema.id)"> Gerar </a>
              </b-col>
            </b-row>
            <b-row v-if="modalTipo === 'Credenciais'">
              <b-col cols="9">
                <b-form-group label="Client Secret:">
                  <b-input-group class="mb-6">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  :readonly="true"
                                  v-model.trim="sistema.client_secret"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="3" style="padding-top: 30px">
                <a v-if="can('sistema.generateKey')" class="btn btn-sm btn-secondary action" @click="getKey(sistema.id)"> Gerar </a>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  components: {
    Pagination,
    Multiselect
  },
  created () {
    if (!this.can('sistema.index')) {
      this.$router.push('/')
    } else {
      this.$store.dispatch('getPerfis')
    }
  },
  data () {
    return {
      totalPorPagina: 10,
      resource: 'sistemas',
      modalControl: false,
      modalTipo: '',
      titulo_descricao: '',
      idAlterar: '',
      titulo_botao: '',
      credenciais: '',
      situacoes: [
        { value: '', text: 'Selecione' },
        { value: 1, text: 'Ativo' },
        { value: false, text: 'Inativo' }
      ],
      filtros: {
        filter: '',
        numCadastro: null,
        areaResponsavel: null,
        situacao: ''
      }
    }
  },
  computed: {
    perfilAtual () {
      return this.$store.state.sistema.perfilAtual
    },
    sistemas () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    perfis () {
      return this.$store.state.perfil.lista
    },
    sistema () {
      return this.$store.state.sistema.sistemaEditar
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.numCadastro': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.areaResponsavel': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.situacao': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    resetForm () {
      this.filtros.filter = null
      this.filtros.numCadastro = null
      this.filtros.areaResponsavel = null
      this.filtros.situacao = ''
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizarSistema (id) {
      this.$router.push('/sistema/visualizar/' + id)
    },
    editarSistema (id) {
      this.$router.push('/sistema/editar/' + id)
    },
    modal (id, tipo) {
      this.$store.dispatch('getSistema', id)

      this.idAlterar = id
      this.modalTipo = tipo

      this.credenciais = tipo === 'Credenciais'

      this.titulo_descricao = tipo === 'Credenciais' ? 'Alterar Credenciais' : tipo + ' Sistema Cliente'
      this.titulo_botao = tipo === 'Credenciais' ? 'Alterar' : tipo

      this.modalControl = true
    },
    modalConfirma () {
      if (this.modalTipo === 'Excluir') {
        this.excluirSistema(this.idAlterar)
      }

      if (this.modalTipo === 'Ativar') {
        this.ativarSistema(this.idAlterar)
      }

      if (this.modalTipo === 'Desativar') {
        this.inativarSistema(this.idAlterar)
      }

      this.idAlterar = ''
      this.modalTipo = ''
    },
    excluirSistema (id) {
      this.$bvModal.msgBoxConfirm('Confirma a exlusão do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/sistema/' + this.sistema.id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    inativarSistema (id) {
      this.$bvModal.msgBoxConfirm('Confirma a inativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/sistema/inativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    ativarSistema (id) {
      this.$bvModal.msgBoxConfirm('Confirma a ativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/sistema/ativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    getId (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente gerar um novo Client ID?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/sistema/alterarClientId/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getSistema', id)
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getSistema', id)
        }
      })
    },
    getKey (id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente gerar um novo Client Secret?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/sistema/alterarClientSecret/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getSistema', id)
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getSistema', id)
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/sistemas/SistemasClientes.vue